import "./singlePublisher.scss";
import Chart from "../../components/chart/Chart";
import Navbar from "../../components/navbar/Navbar";
import Sidebar from "../../components/sidebar/Sidebar";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  collection,
  doc,
  getDoc,
  getDocs,
  updateDoc,
  addDoc,
} from "firebase/firestore";
import { db } from "../../firebase";
import {
  Backdrop,
  Box,
  Button,
  Card,
  Chip,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Fab,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  InputAdornment,
  Radio,
  RadioGroup,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import UserOrderTableList from "../../components/userOrderTable/userOrderTable";
import { Add, Edit } from "@mui/icons-material";
import { handleInputNumber } from "../../context/commonFunctions";
import PublisherDatatable from "../../components/publisherDatatable/publisherDatatable";
import { generateKeywords } from "../../functions";
import WalletList from "./walletList";
import { ShowSnackBar } from "../../components/modal";
import { green, red } from "@mui/material/colors";

function SinglePublisher() {
  const { publisherId } = useParams();
  const [openToast, setOpenToast] = useState(false);
  const [publisherData, setpublisherData] = useState({});
  const [ordersData, setOrdersData] = useState();
  const [publishedOn, setPublishedOn] = useState();
  const navigate = useNavigate();
  const [openLoading, setLoading] = useState(false);
  const [initialLoading, setInitialLoading] = useState(true);
  const [isDataAvailable, setDataAvailable] = useState(false);
  const [isOrdersAvailable, setOrdersAvailable] = useState(false);
  const [updateData, setUpdateData] = useState(0);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [transactionAmount, setTransactionAmount] = useState("");
  const [transactionMessage, setTransactionMessage] = useState("");
  const [transactionTitle, setTransactionTitle] = useState("");
  const [transactionType, setTransactionType] = useState("credit");
  const [transactionLoading, setTransactionLoading] = useState(false);
  const [transactionError, setTransactionError] = useState({
          amount: "",
    message: "",
    title: "",
  });

  const [controlChips, setControlChips] = useState({
    l: "default",
    f: "default",
  });
  const [errorMessage, setErrorMessage] = useState(
    "Something went wrong.\nPlease try again"
  );
  const [formData, setFormData] = useState({
    fullName: "",
    phoneNumber: "",
    experience: 0,
    booksWritten: 0,
    currentInstitute: "",
    city: "",
    pincode: 0,
    department: "",
    commission: 0,
  });
  const [formErrors, setFormErrors] = useState({
    fullName: "",
    phoneNumber: "",
    experience: "",
    booksWritten: "",
    currentInstitute: "",
    city: "",
    pincode: "",
    department: "",
    commission: "",
  });
  useEffect(async () => {
    try {
      const publisherRef = doc(db, "publishers", publisherId);
      const docSnap = await getDoc(publisherRef);

      if (docSnap.exists()) {
        const epublisherData = docSnap.data();
        const publisherDataWithId = { ...epublisherData, id: docSnap.id };
        setpublisherData(publisherDataWithId);
        document.title = "" + epublisherData.fullName;
        if (epublisherData.controlAccess === "limited") {
          setControlChips({ l: "primary", f: "default" });
        } else {
          setControlChips({ l: "default", f: "primary" });
}

        setFormData({
          fullName: epublisherData.fullName,
          phoneNumber: epublisherData.phoneNumber,
          experience: epublisherData.experience,
          booksWritten: epublisherData.booksWritten,
          currentInstitute: epublisherData.currentInstitute,
          city: epublisherData.city,
          pincode: epublisherData.pincode,
          department: epublisherData.department,
          commission: epublisherData.commission,
        });

        setDataAvailable(true);
        setInitialLoading(false);
      } else {
        setInitialLoading(false);
        setErrorMessage("There is no such user available. Please try again.");
      }
    } catch (error) {
      setInitialLoading(false);
      setErrorMessage("Error - " + error);
    }
  }, [updateData]);

  const handleControlChange = async (value) => {
    try {
      const publisherRef = doc(db, "publishers", publisherId);
      setLoading(true);
      await updateDoc(publisherRef, { controlAccess: value });
      if (value === "limited") {
        setControlChips({ l: "primary", f: "default" });
      } else {
        setControlChips({ l: "default", f: "primary" });
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      alert(error.message);
    }
  };

  const validateForm = () => {
    const errors = {
      fullName: "",
      phoneNumber: "",
      experience: "",
      booksWritten: "",
      currentInstitute: "",
      city: "",
      pincode: "",
      department: "",
      commission: "",
    };

    let isValid = true;

    if (!formData.fullName.trim()) {
      errors.fullName = "Publisher Name cannot be empty";
      isValid = false;
    }
    if (!formData.phoneNumber.trim() || formData.phoneNumber.length < 10) {
      errors.phoneNumber = "Invalid Phone number";
      isValid = false;
    }
    if (!formData.experience) {
      errors.experience = "Experience cannot be empty";
      isValid = false;
    }
    if (!formData.commission) {
      errors.commission = "Commission cannot be empty";
      isValid = false;
    }
    if (!formData.booksWritten) {
      errors.booksWritten = "No. of books written cannot be empty/zero";
      isValid = false;
    }
    if (!formData.currentInstitute.trim()) {
      errors.currentInstitute = "Institute name cannot be empty";
      isValid = false;
    }
    if (!formData.city.trim()) {
      errors.city = "City cannot be empty";
      isValid = false;
    }
    if (!formData.department.trim()) {
      errors.department = "Department cannot be empty";
      isValid = false;
    }
    if (!formData.pincode || formData.pincode === 0) {
      errors.pincode = "Pincode cannot be empty/zero";
      isValid = false;
    }
    setFormErrors(errors);

    return isValid;
  };
  const handleSubmit = async (e) => {
    if (validateForm()) {
      setLoading(true);
      try {
        var mapData = formData;
        mapData = {
          ...mapData,
          searchKeywords: generateKeywords(formData.fullName),
        };
        const publisherRef = doc(db, "publishers", publisherId);
        await updateDoc(publisherRef, mapData);
        setLoading(false);
        setUpdateData(updateData + 1);
        setOpenSnackbar(true);
        setSnackBarMessage("Details have been updated.");
        setSnackBarType("success");
      } catch (error) {
        setLoading(false);
        setOpenSnackbar(true);
        setSnackBarMessage("Error updating publisher account: " + error);
        setSnackBarType("error");
      }
    }
  };

  const [openSnackBar, setOpenSnackbar] = useState(false);
  const [snackBarMessage, setSnackBarMessage] = useState("");
  const [snackBarType, setSnackBarType] = useState("success");
  const handleCloseSnackBar = () => {
    setOpenSnackbar(false);
  };

  return (
    <>
      <div className="singlePublisher">
        <Sidebar />
        <ShowSnackBar
          message={snackBarMessage}
          type={snackBarType}
          openSnackBar={openSnackBar}
          handleCloseSnackBar={handleCloseSnackBar}
        />

        {initialLoading && (
          <div className="singlePublisherContainer">
            <div className="intialItem">
              <CircularProgress />
            </div>
          </div>
        )}
        {!initialLoading && !isDataAvailable && (
          <div className="singlePublisherContainer">
            <div className="intialItem">{errorMessage}</div>
          </div>
        )}
        {!initialLoading && isDataAvailable && (
          <div className="singlePublisherContainer">
            <Navbar />
            <h1 className="title">Publisher Profile</h1>
            <div className="top">
              <div className="left">
                <div className="item">
                  <div className="formInput" key={"fullName"}>
                    <TextField
                      fullWidth
                      id="outlined-multiline-static"
                      label="Full Name"
                      defaultValue={publisherData.fullName}
                      onChange={(e) => {
                        setFormData({
                          ...formData,
                          fullName: e.target.value,
                        });
                      }}
                      error={formErrors.fullName !== ""}
                      helperText={formErrors.fullName}
                    />
                  </div>
                  <div className="formInput" key={"phoneNumber"}>
                    <TextField
                      fullWidth
                      id="outlined-multiline-static"
                      label="Phone number"
                      onInput={handleInputNumber}
                      defaultValue={publisherData.phoneNumber}
                      inputProps={{ maxLength: 10 }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">+91</InputAdornment>
                        ),
                      }}
                      onChange={(e) => {
                        setFormData({
                          ...formData,
                          phoneNumber: e.target.value,
                        });
                      }}
                      error={formErrors.phoneNumber !== ""}
                      helperText={formErrors.phoneNumber}
                    />
                  </div>

                  <div className="formInput" key={"experience"}>
                    <TextField
                      fullWidth
                      id="outlined-multiline-static"
                      label="Teaching Experience"
                      inputProps={{ maxLength: 2 }}
                      defaultValue={
                        new Date().getFullYear() - publisherData.experience
                      }
                      onInput={handleInputNumber}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">years</InputAdornment>
                        ),
                      }}
                      onChange={(e) => {
                        const currentYear = new Date().getFullYear();
                        setFormData({
                          ...formData,
                          experience:
                            currentYear - (parseInt(e.target.value, 10) || 0),
                        });
                      }}
                      error={formErrors.experience !== ""}
                      helperText={formErrors.experience}
                    />
                  </div>
                  <div className="formInput" key={"booksWritten"}>
                    <TextField
                      fullWidth
                      onInput={handleInputNumber}
                      inputProps={{ maxLength: 4 }}
                      defaultValue={publisherData.booksWritten}
                      id="outlined-multiline-static"
                      label="No. of Books Written"
                      onChange={(e) => {
                        setFormData({
                          ...formData,
                          booksWritten: e.target.value,
                        });
                      }}
                      error={formErrors.booksWritten !== ""}
                      helperText={formErrors.booksWritten}
                    />
                  </div>
                  <div className="formInput" key={"currentInstitute"}>
                    <TextField
                      fullWidth
                      id="outlined-multiline-static"
                      label="Current College or Institution Name"
                      defaultValue={publisherData.currentInstitute}
                      onChange={(e) => {
                        setFormData({
                          ...formData,
                          currentInstitute: e.target.value,
                        });
                      }}
                      error={formErrors.currentInstitute !== ""}
                      helperText={formErrors.currentInstitute}
                    />
                  </div>
                  <div className="formInput" key={"city"}>
                    <TextField
                      fullWidth
                      id="outlined-multiline-static"
                      label="City of Residence"
                      defaultValue={publisherData.city}
                      onChange={(e) => {
                        setFormData({ ...formData, city: e.target.value });
                      }}
                      error={formErrors.city !== ""}
                      helperText={formErrors.city}
                    />
                  </div>

                  <div className="formInput" key={"pincode"}>
                    <TextField
                      fullWidth
                      onInput={handleInputNumber}
                      defaultValue={publisherData.pincode}
                      id="outlined-multiline-static"
                      inputProps={{ maxLength: 6 }}
                      label="Pincode"
                      onChange={(e) => {
                        setFormData({ ...formData, pincode: e.target.value });
                      }}
                      error={formErrors.pincode !== ""}
                      helperText={formErrors.pincode}
                    />
                  </div>

                  <div className="formInput" key={"department"}>
                    <TextField
                      fullWidth
                      defaultValue={publisherData.department}
                      id="pages"
                      label="Academic Department"
                      onChange={(e) => {
                        setFormData({
                          ...formData,
                          department: e.target.value,
                        });
                      }}
                      error={formErrors.department !== ""}
                      helperText={formErrors.department}
                    />
                  </div>
                  <div className="formInput" key={"commission"}>
                    <TextField
                      fullWidth
                      id="outlined-multiline-static"
                      label="Enter commission rate (per copy)"
                      onInput={handleInputNumber}
                      defaultValue={publisherData.commission}
                      inputProps={{ maxLength: 2 }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">%</InputAdornment>
                        ),
                      }}
                      onChange={(e) => {
                        setFormData({
                          ...formData,
                          commission: parseInt(e.target.value, 10) || 0,
                        });
                      }}
                      error={formErrors.commission !== ""}
                      helperText={formErrors.commission}
                    />
                  </div>
                </div>
                <div className="updateButton">
                  <Button
                    variant="contained"
                    sx={{ width: "40%" }}
                    onClick={handleSubmit}
                  >
                    Update
                  </Button>
                </div>
              </div>
            </div>
            <div className="bottom">
              <div className="detailItem">
                <Card variant="elevation" sx={{ padding: "20px" }}>
                  <Box sx={{ p: 2 }}>
                    <Typography
                      gutterBottom
                      variant="body1"
                      sx={{ marginBottom: "10px" }}
                    >
                      Account Control
                    </Typography>
                    <Stack direction="row" spacing={1}>
                      <Chip
                        color={controlChips.l}
                        label="Limited Access"
                        size="small"
                        onClick={() => handleControlChange("limited")}
                      />
                      <Chip
                        color={controlChips.f}
                        label="Full Access"
                        size="small"
                        onClick={() => handleControlChange("full")}
                      />
                    </Stack>
                  </Box>
                  <Box sx={{ p: 2 }}>
                    <Stack
                      direction="row"
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      <Stack direction="column" spacing={1}>
                        <Typography gutterBottom variant="h6">
                          Total Commission earned
                        </Typography>
                        <Typography gutterBottom variant="body2">
                          ₹{publisherData.totalSale}
                        </Typography>
                      </Stack>
                      <Stack direction="column" spacing={1}>
                        <Typography gutterBottom variant="h6">
                          Total Units Sold
                        </Typography>

                        <Typography gutterBottom variant="body2">
                          {publisherData.unitSold}
                        </Typography>
                      </Stack>
                    </Stack>
                  </Box>

                  <Box sx={{ p: 2 }}>
                    <Stack
                      direction="row"
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      <Stack direction="row">
                        <Typography variant="h5" component="div">
                          Wallet Balance:
                        </Typography>
                        <Typography
                          variant="h6"
                          component="div"
                          sx={{marginLeft:"10px"}}
                          color={
                            publisherData.walletBalance > 0 ? "green" : "red"
                          }
                          textAlign="right"
                        >
                          {"₹" + publisherData.walletBalance}
                        </Typography>
                      </Stack>
<Fab 
  color="primary" 
  variant="extended" 
  onClick={() => {
    setDialogOpen(true);
  }}
>
                        <Add sx={{ mr: 1 }} />
                        Add Transaction
                      </Fab>
<Dialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
  <DialogTitle>Add Transaction</DialogTitle>
  <DialogContent>
    <TextField
      autoFocus
      margin="dense"
      label="Title"
      type="text"
      fullWidth
      value={transactionMessage}
      onChange={(e) => setTransactionMessage(e.target.value)}
      error={transactionError.message !== ""}
      helperText={transactionError.message}
      
    />
    <TextField
      margin="dense"
      label="Amount"
      type="text"
      fullWidth
      value={transactionAmount}
      onChange={(e) => {
        const value = e.target.value.replace(/[^0-9]/g, '');
        setTransactionAmount(value);
      }}
      error={transactionError.amount !== ""}
      helperText={transactionError.amount}
    />
    <TextField
      margin="dense"
      label="Message"
      type="text"
      fullWidth
      value={transactionTitle}
      onChange={(e) => setTransactionTitle(e.target.value)}
      error={transactionError.title !== ""}
      helperText={transactionError.title}
    />
    <FormControl component="fieldset" sx={{ mt: 2 }}>
      <FormLabel component="legend">Transaction Type</FormLabel>
      <RadioGroup
        row
        value={transactionType}
        onChange={(e) => setTransactionType(e.target.value)}
      >
        <FormControlLabel value="credit" control={<Radio />} label="Credit" />
        <FormControlLabel value="debit" control={<Radio />} label="Debit" />
      </RadioGroup>
    </FormControl>
  </DialogContent>
  <DialogActions>
    <Button onClick={() => setDialogOpen(false)}>Cancel</Button>
    <Button 
      onClick={async () => {
        const errors = {
          amount: "",
          message: "",
          title: ""
        };
        let isValid = true;
        
        if (!transactionAmount) {
          errors.amount = "Amount is required";
          isValid = false;
        }

        if (!transactionMessage.trim()) {
          errors.message = "Message is required";
          isValid = false;
        }
        
        if (!transactionTitle.trim()) {
          errors.title = "Title is required";
          isValid = false;
        }
        
        setTransactionError(errors);
        
        if (isValid) {
          setTransactionLoading(true);
          try {
            const transactionData = {
              amount: Number(transactionAmount),
              message: transactionMessage,
              title: transactionTitle,
              type: transactionType,
              timestamp: new Date()
            };
            
            await addDoc(collection(db, `publishers/${publisherId}/transactions`), transactionData);
            
            // Update wallet balance
            const publisherRef = doc(db, "publishers", publisherId);
            const newBalance = transactionType === "credit" 
              ? publisherData.walletBalance + Number(transactionAmount)
              : publisherData.walletBalance - Number(transactionAmount);
              
            await updateDoc(publisherRef, { walletBalance: newBalance });
            
            setDialogOpen(false);
            setTransactionAmount("");
            setTransactionMessage("");
            setTransactionTitle("");
            setTransactionType("credit");
            setUpdateData(updateData + 1);
            
            setOpenSnackbar(true);
            setSnackBarMessage("Transaction added successfully");
            setSnackBarType("success");
          } catch (error) {
            setOpenSnackbar(true);
            setSnackBarMessage("Error adding transaction: " + error.message);
            setSnackBarType("error");
          } finally {
            setTransactionLoading(false);
          }
        }
      }}
      disabled={transactionLoading}
    >
      {transactionLoading ? <CircularProgress size={24} /> : "Add"}
    </Button>
  </DialogActions>
</Dialog>
                    </Stack>
                  </Box>
                  <Box sx={{ p: 2 }}>
                    <WalletList publisherId={publisherId} />
                  </Box>
                </Card>
              </div>
            </div>
            <div className="bottom">
              <div className="detailItem">
                <Card variant="elevation" sx={{ padding: "20px" }}>
                  Book List
                  <PublisherDatatable publisherID={publisherId} />
                </Card>
              </div>
            </div>
          </div>
        )}
      </div>
      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
        open={openLoading}
      >
        <Grid
          container
          direction="column"
          justifyContent="center"
          alignItems="center"
        >
          <CircularProgress
            color="inherit"
            value={10}
            sx={{ marginBottom: "15px" }}
          />
          <Typography>{true}</Typography>
        </Grid>
      </Backdrop>
    </>
  );
}

export default SinglePublisher;
